import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "./useFeatureFlags";
import { useMemo } from "react";

export function useDocumentAI() {
  const { featureFlags } = useFeatureFlags();
  return useMemo(
    () => featureFlags?.[FeatureFlagKey.DocumentAI] ?? false,
    [featureFlags]
  );
}
